import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/PepperAnalizaHome";
import Info from "./pages/PepperAnalizaInfo";
import Delivery from "./pages/PepperAnalizaDelivery";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/info", element: <Info /> },
  { path: "/delivery", element: <Delivery /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}